import useFormOperations from "@Totum/QuestionnaireBuilder/Application/hooks/useFormOperations";
import { showQuestionnaireUpdatedNotification } from "@Totum/QuestionnaireBuilder/Presentation//helpers";
import { createEditorStateFromRawDraftJs, createEditorStateFromText, tryParseDraftJsContent } from "@Totum/Main/Utils";
import { EditorState } from "draft-js";
import { useCallback } from "react";

/**
 * Presents the `LearningObjectivesForm` component with the UI model and handlers.
 */
const useLearningObjectivesFormPresenter = () => {
    const { questionnaire, updateLearningObjectives } = useFormOperations();

    const handleEditorChange = useCallback(
        async (content: string) => {
            // no need to debounce this call

            const operationResult = await updateLearningObjectives(content);
            if (operationResult.hasAction) {
                showQuestionnaireUpdatedNotification(operationResult.isSuccess, questionnaire.title);
            }
        },
        [questionnaire.title, updateLearningObjectives]
    );

    const prepareInitialContent = (description?: string): EditorState => {
        if (!description) {
            return EditorState.createEmpty();
        }

        const isValidDraftJsContent = tryParseDraftJsContent(description);

        if (isValidDraftJsContent) {
            return createEditorStateFromRawDraftJs(description);
        }

        return createEditorStateFromText(description);
    };

    const initialContent = prepareInitialContent(questionnaire.learningObjectiveDetails?.description);

    return {
        handlers: {
            handleEditorChange,
        },
        uiModel: {
            questionnaireId: questionnaire.questionnaireId,
            initialContent,
        },
    };
};

export default useLearningObjectivesFormPresenter;
